import React from 'react';

const ProcessIcon = ({ icon, label, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center text-center cursor-pointer transition-transform duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-ifys-blue focus:ring-offset-2 rounded-lg"
      aria-label={`Learn more about ${label}`}
    >
      <div
        className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-ifys-perk-light flex items-center justify-center mb-3 sm:mb-4"
      >
        <div className="text-8xl flex items-center justify-center text-ifys-blue">
          {icon}
        </div>
      </div>
      <span className="text-ifys-blue font-medium text-sm sm:text-base whitespace-pre-line leading-tight">
        {label}
      </span>
    </button>
  );
};

export default ProcessIcon;
